export default __webpack_public_path__ + "static/media/fauna-abac-framed.66ecb856.png";